import React, { useState, useEffect } from 'react';
import './VariationModal.css';

const VariationModal = ({ item, isOpen, onClose, onConfirm, selectedVariations, onVariationChange }) => {
  const [localVariations, setLocalVariations] = useState(selectedVariations);

  useEffect(() => {
    if (isOpen && item) {
      // Set default selections when modal opens
      const defaultSize = item.sizes && item.sizes.length > 0 ? item.sizes[0].name : null;
      const defaultSpice = item.spiceLevels && item.spiceLevels.length > 0 ? item.spiceLevels[0] : null;
      setLocalVariations({
        size: defaultSize,
        spice: defaultSpice,
        addons: []
      });
    }
  }, [isOpen, item]);

  useEffect(() => {
    if (onVariationChange) {
      onVariationChange(localVariations);
    }
  }, [localVariations, onVariationChange]);

  if (!isOpen || !item) return null;

  const calculatePrice = () => {
    let price = item.price;
    
    // Add size price if selected
    if (localVariations.size && item.sizes) {
      const selectedSizeObj = item.sizes.find(s => s.name === localVariations.size);
      if (selectedSizeObj && selectedSizeObj.price) {
        price = selectedSizeObj.price;
      }
    }
    
    // Add addon prices
    if (localVariations.addons && localVariations.addons.length > 0) {
      const addonsTotal = localVariations.addons.reduce((sum, addonId) => {
        const addon = item.addons.find(a => a.id === addonId);
        return sum + (addon ? addon.price : 0);
      }, 0);
      price += addonsTotal;
    }
    
    return price;
  };

  const handleSizeChange = (sizeName) => {
    setLocalVariations(prev => ({ ...prev, size: sizeName }));
  };

  const handleSpiceChange = (spiceLevel) => {
    setLocalVariations(prev => ({ ...prev, spice: spiceLevel }));
  };

  const handleAddonToggle = (addonId) => {
    setLocalVariations(prev => {
      const addons = prev.addons || [];
      if (addons.includes(addonId)) {
        return { ...prev, addons: addons.filter(id => id !== addonId) };
      } else {
        return { ...prev, addons: [...addons, addonId] };
      }
    });
  };

  const handleConfirm = () => {
    onConfirm(localVariations);
  };

  return (
    <div className="variation-modal-overlay" onClick={onClose}>
      <div className="variation-modal" onClick={(e) => e.stopPropagation()}>
        <div className="variation-modal-header">
          <h2 className="variation-modal-title">{item.name}</h2>
          <button className="variation-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="variation-modal-content">
          {item.sizes && item.sizes.length > 0 && (
            <div className="variation-section">
              <h3 className="variation-section-title">Size</h3>
              <div className="variation-options">
                {item.sizes.map((size, index) => (
                  <button
                    key={index}
                    className={`variation-option ${localVariations.size === size.name ? 'selected' : ''}`}
                    onClick={() => handleSizeChange(size.name)}
                  >
                    <span className="variation-option-name">{size.name}</span>
                    {size.price && size.price !== item.price && (
                      <span className="variation-option-price">
                        +Rs. {size.price.toFixed(2)}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>
          )}

          {item.spiceLevels && item.spiceLevels.length > 0 && (
            <div className="variation-section">
              <h3 className="variation-section-title">Spice Level</h3>
              <div className="variation-options">
                {item.spiceLevels.map((spice, index) => (
                  <button
                    key={index}
                    className={`variation-option ${localVariations.spice === spice ? 'selected' : ''}`}
                    onClick={() => handleSpiceChange(spice)}
                  >
                    <span className="variation-option-name">{spice}</span>
                  </button>
                ))}
              </div>
            </div>
          )}

          {item.addons && item.addons.length > 0 && (
            <div className="variation-section">
              <h3 className="variation-section-title">Add-ons</h3>
              <div className="variation-options">
                {item.addons.map((addon) => (
                  <label
                    key={addon.id}
                    className={`variation-option checkbox-option ${localVariations.addons?.includes(addon.id) ? 'selected' : ''}`}
                  >
                    <input
                      type="checkbox"
                      checked={localVariations.addons?.includes(addon.id) || false}
                      onChange={() => handleAddonToggle(addon.id)}
                    />
                    <span className="variation-option-name">{addon.name || addon.icon}</span>
                    {addon.price > 0 && (
                      <span className="variation-option-price">
                        +Rs. {addon.price.toFixed(2)}
                      </span>
                    )}
                  </label>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="variation-modal-footer">
          <div className="variation-modal-price">
            <span className="price-label">Total:</span>
            <span className="price-value">Rs. {calculatePrice().toFixed(2)}</span>
          </div>
          <button className="variation-modal-confirm-btn" onClick={handleConfirm}>
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default VariationModal;

